import type { SkeletonProps } from 'primevue/skeleton'

interface TwnSkeletonProps extends /* @vue-ignore */ SkeletonProps {
  shape?: 'rectangle' | 'circle' | string
  size?: string
  width?: string
  height?: string
  borderRadius?: string
}

const DEFAULT_TWN_SKELETON_PROPS = {
  shape: 'rectangle',
  width: '100%',
  height: '1rem'
} as const

export type { TwnSkeletonProps }
export { DEFAULT_TWN_SKELETON_PROPS }
